<template>
    <div v-if="model">

        <FormBusca
            :form="form"
            :model="model"
            :additionals="additionals"
            :consultas="consultas"
            @cleaned="cleaned"
            @searched="searched"
            ref="FormBusca"
        />

        <ListBusca
            :additionals="additionals"
            :form="form"
            :isSearch="isSearch"
            :selecionados="selecionados"
            :consultas="consultas"
            :especialidadesJornada="especialidadesJornada"
            @handleSelecionado="handleSelecionado"
            @canceled="$refs.FormBusca.search()"
            @deleted="$refs.FormBusca.search()"
            @updated="$refs.FormBusca.search()"
        />
    </div>
</template>

<script>
// Components.
import FormBusca from './components/busca/Form'
import ListBusca from './components/busca/List'

// Enums.
import procedimento from '@/enums/atencao-basica/atendimento-odontologico/procedimento'
import agendamentoStatus from '@/enums/ambulatorio/agendamentoStatus'
import procedimentoObrigatorio from '@/enums/ambulatorio/procedimentoObrigatorio'

// Mixins.
import {error, mask, object, repository, data, formats, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        FormBusca,
        ListBusca,
    },
    created() {
        this.repositories = {
            fechamento: this.getConectaSusRepository('ambulatorio.fechamentoConsulta'),
        }
    },
    data: () => ({
        additionals: null,
        form: null,
        consultas: [],
        atendimentoId: null,
        model: null,
        others: {moment},
        isSearch: false,
        selecionados: false,
        especialidadesJornada: [],
        enums: {
            procedimento,
            agendamentoStatus,
            procedimentoObrigatorio
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.fechamento.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.addWatch()

                    this.$emit('loaded', {additionals: this.additionals, form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        searched(data) {
            this.consultas = data.consultas.map(consulta => ({...consulta, selecionado: false}))
            this.atendimentoId = data.consultas.map(c => c.atendimentoId)
            this.especialidadesJornada = data.especialidades
            this.isSearch = true
            this.selecionados = false
        },
        cleaned(consultas) {
            this.consultas = consultas
            this.isSearch = false
            this.selecionados = false
        },
        resetFormBusca() {
            this.$refs.FormBusca.resetForm()
        },
        handleSelecionado(value) {
            this.selecionados = value
        },
        addWatch() {
            this.$watch('model', {
                deep: true,
                handler() {
                    this.consultas = []
                },
            })
        },
        handleSave() {

            let consultasComProtocoloFechamento = this.consultas.filter(consulta =>
                consulta.statusId == this.enums.agendamentoStatus.REALIZADO
                && consulta.numero
                && consulta.numero !== consulta.protocoloFechamento
                && (consulta.protocoloFechamento !== null && consulta.protocoloFechamento !== 0)
            )

            if (consultasComProtocoloFechamento.length > 0) {
                this.showValidationNotification('Existe(m) protocolo(s) de fechamento não informado(s) e/ou inválido(s).')
                return
            }

            const consultasSemProc = this.clone(this.consultas.filter(consulta =>
                  ( consulta.statusId === this.enums.agendamentoStatus.REALIZADO &&
                    consulta.usuarioId &&
                    (consulta.especialidadeSemProc === null || consulta.especialidadeSemProc === this.enums.procedimentoObrigatorio.NAO_PERMITE_SEM_PROCEDIMENTO) &&
                    !consulta.procedimento && consulta.procedimentos.length === 0)
            ));

            if (consultasSemProc.length > 0) {
                const especialidadesDesc = consultasSemProc.map(item => item.especialidade).join(', ');
                this.showAlert(`As especialidades a seguir não podem ser finalizadas sem um procedimento: ${especialidadesDesc}`, "Atenção");
                return false;
            }

            const hasConsultaAlterada = this.consultas.find(consulta =>
                consulta.statusId == this.enums.agendamentoStatus.FALTA_DO_PACIENTE
                || consulta.statusId == this.enums.agendamentoStatus.FALTA_DO_MEDICO
                || (consulta.statusId == this.enums.agendamentoStatus.REALIZADO && consulta.usuarioId));

            if (!hasConsultaAlterada) {

                this.showAlert(`A finalização não pode ser efetuada, pois não há consultas com status e usuário
                    modificados.`, "Atenção")
                return false
            }

            const hasQuantidadeNull = this.consultas.some(consulta => consulta.procedimento && consulta.quantidade === null);

            if (hasQuantidadeNull) {

                this.showAlert(`A finalização não pode ser efetuada, pois há consultas sem a quantidade informada.`, "Atenção")

                return false
            }

            const hasCidNull = this.consultas.some(consulta => consulta.procedimento && consulta.procedimento.hasCidPrincipal && consulta.cid === null);

            if (hasCidNull) {

                this.showAlert(`A finalização não pode ser efetuada, pois há consultas sem o CID informado.`, "Atenção")

                return false
            }

            const hasStatusNull = this.consultas.some(consulta => consulta.statusId === null ||
                consulta.usuaruioId === null);

            if (hasStatusNull) {

                this.showConfirmation(
                    `As consultas sem status informados ou sem profissional vinculado não serão atualizadas. Deseja continuar?`,
                    async () => this.save(),
                )

                return false
            }

            let consultas = this.consultas.filter(consulta =>
                consulta.statusId == this.enums.agendamentoStatus.REALIZADO
            )

            let consultaNaoCriaFicha = consultas.some(consulta =>
                (consulta.criaFichaAtendimentoIndividual === true && (consulta.atendimentoIndividual === null || consulta.atendimentoIndividual === undefined))
                ||
                ( consulta.criaFichaAtendimentoOdontologico === true && (consulta.atendimentoOdontologico === null || consulta.atendimentoOdontologico === undefined))
            )

            if (consultaNaoCriaFicha) {
                 this.showConfirmation(
                    `Existem consultas não preenchidas no botão Atenção Básica. Essas fichas não serão criadas. Deseja continuar?`,
                    async () => this.save(),
                )
                return false
            }

            this.save()
        },
        save() {

            this.setLoading()

            this.repositories.fechamento.store(this.prepareData())
                .then(({ data }) => {

                    this.showSaveNotification()
                    this.$emit('saved', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        prepareData() {

            let consultas = this.clone(this.consultas.filter(consulta =>
                consulta.statusId == this.enums.agendamentoStatus.FALTA_DO_PACIENTE
                || consulta.statusId == this.enums.agendamentoStatus.FALTA_DO_MEDICO
                || (consulta.statusId == this.enums.agendamentoStatus.REALIZADO && consulta.usuarioId)))

            consultas.forEach(item => {

                if (item.atendimentoIndividual) {

                    if (item.procedimento) {

                        item.procedimento.usuarioId = item.usuarioId
                        item.procedimentos.push(item.procedimento)
                    }

                    item.atendimentoIndividual.procedimentos = item.procedimentos
                        .filter(procedimento => procedimento.usuarioId === item.usuarioId)

                    item.atendimentoIndividual.procedimentos.forEach(procedimento => {
                        procedimento.procedimentoId = procedimento.id
                    });

                    item.atendimentoIndividual.atendimento.problemasCondicoes = item.atendimentoIndividual.atendimento.problemasCondicoes.map(problemaCondicao => {
                        return {
                            id: problemaCondicao.id,
                            problemaCondicaoAnteriorId: problemaCondicao.problemaCondicaoAnteriorId,
                            automatico: problemaCondicao.automatico,
                            ciapId: problemaCondicao.ciap ? problemaCondicao.ciap.id : null,
                            cidId: problemaCondicao.cid ? problemaCondicao.cid.id : null,
                            situacaoId: problemaCondicao.situacaoId,
                            inicio: problemaCondicao.inicio ? problemaCondicao.inicio.data : null,
                            fim: problemaCondicao.fim ? problemaCondicao.fim.data : null,
                            observacao: problemaCondicao.observacao,
                        }
                    })

                    item.atendimentoIndividual.atendimento.dum = item.atendimentoIndividual.atendimento.dum
                        ? this.getFormatedDate(item.atendimentoIndividual.atendimento.dum, 'YYYY-MM-DD')
                        : null

                    if (!item.ocupacaoId) {

                        const especialidade = item.especialidadesJornada
                            .find(especialidade => especialidade.id === item.especialidadeId);

                        if (especialidade) {
                            item.ocupacaoId = especialidade.ocupacao.id;
                        }
                    }
                }

                if (item.atendimentoOdontologico) {

                    item.procedimentosQuantidade = []

                    item.atendimentoOdontologico.usuarioId = item.usuarioId
                    item.atendimentoOdontologico.ocupacaoId = item.atendimentoOdontologico.cadastro.ocupacaoId
                    item.atendimentoOdontologico.usuarioAuxiliarId = item.atendimentoOdontologico.cadastro.usuarioAuxiliar.id
                    item.atendimentoOdontologico.ocupacaoAuxiliarId = item.atendimentoOdontologico.cadastro.ocupacaoAuxiliarId
                    item.atendimentoOdontologico.dataAtendimento = item.atendimentoOdontologico.cadastro.dataAtendimento
                    item.atendimentoOdontologico.turnoId = item.atendimentoOdontologico.atendimento.turnoId
                    item.atendimentoOdontologico.localAtendimentoId = item.atendimentoOdontologico.atendimento.localAtendimentoId
                    item.atendimentoOdontologico.tipoAtendimentoId = item.atendimentoOdontologico.atendimento.tipoAtendimentoId
                    item.atendimentoOdontologico.tipoConsultaId = item.atendimentoOdontologico.atendimento.tipoConsultaId
                    item.atendimentoOdontologico.necessidadesEspeciais = item.atendimentoOdontologico.atendimento.necessidadesEspeciais
                    item.atendimentoOdontologico.gestante = item.atendimentoOdontologico.atendimento.gestante
                    item.atendimentoOdontologico.unidadeId = item.atendimentoOdontologico.cadastro.unidadeId
                    item.atendimentoOdontologico.equipeId = item.atendimentoOdontologico.cadastro.equipeId
                    item.atendimentoOdontologico.equipeAuxiliarId = item.atendimentoOdontologico.cadastro.equipeAuxiliarId
                    item.atendimentoOdontologico.escovaDental = item.atendimentoOdontologico.fornecimento.escovaDental
                    item.atendimentoOdontologico.cremeDental = item.atendimentoOdontologico.fornecimento.cremeDental
                    item.atendimentoOdontologico.fioDental = item.atendimentoOdontologico.fornecimento.fioDental

                    if (item.procedimento) {

                        item.procedimento.usuarioId = item.usuarioId
                        item.procedimentos.push(item.procedimento)
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.acessoPolpaDentaria) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.ACESSO_POLPA_DENTARIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.acessoPolpaDentaria
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.adaptacaoProteseDentaria) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.ADAPTACAO_PROTESE_DENTARIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.adaptacaoProteseDentaria
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.aplicacaoCariostatico) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.APLICACAO_CARIOSTATICO,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.aplicacaoCariostatico
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.aplicacaoSelante) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.APLICACAO_SELANTE,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.aplicacaoSelante
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.aplicacaoTopicaFluor) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.APLICACAO_TOPICA_FLUOR,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.aplicacaoTopicaFluor
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.capeamentoPulpar) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.CAPEAMENTO_PULPAR,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.capeamentoPulpar
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.cimentacaoProtese) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.CIMENTACAO_PROTESE_DENTARIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.cimentacaoProtese
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.curativoDemora) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.CURATIVO_DEMORA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.curativoDemora
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.drenagemAbscesso) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.DRENAGEM_ABSCESSO,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.drenagemAbscesso
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.evidenciacaoPlacaBacteriana) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.EVIDENCIACAO_PLACA_BACTERIANA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.evidenciacaoPlacaBacteriana
                        })
                    }
                    if(item.atendimentoOdontologico.procedimentosQuantidade.exodontiaDenteDeciduo) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.EXODONTIA_DENTE_DECIDUO,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.exodontiaDenteDeciduo
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.exodontiaDentePermanente) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.EXODONTIA_DENTE_PERMANENTE,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.exodontiaDentePermanente
                        })
                    }
                    if(item.atendimentoOdontologico.procedimentosQuantidade.instalacaoProteseDentaria) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.INSTALACAO_PROTESE_DENTARIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.instalacaoProteseDentaria
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.moldagemProteseDentaria) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.MOLDAGEM_PROTESE_DENTARIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.moldagemProteseDentaria
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.orientacaoHigieneBucal) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.ORIENTACAO_HIGIENE_BUCAL,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.orientacaoHigieneBucal
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.remocaoPlacaBacteriana) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.REMOCAO_PLACA_BACTERIANA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.remocaoPlacaBacteriana
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.pulpotomiaDentaria) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.PULPOTOMIA_DENTARIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.pulpotomiaDentaria
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.raspagemSupragengivais) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.RASPAGEM_SUPRAGENGIVAIS,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.raspagemSupragengivais
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.raspagemSubgengivais) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.RASPAGEM_SUBGENGIVAIS,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.raspagemSubgengivais
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.restauracaoDentePermanenteAnterior) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.RESTAURACAO_DENTE_PERMANENTE_ANTERIOR,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.restauracaoDentePermanenteAnterior
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.selamentoProvisorioCavidadeDentaria
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.tratamentoAlveolite) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.tratamentoAlveolite
                        })
                    }

                    if(item.atendimentoOdontologico.procedimentosQuantidade.ulotomiaUlectomia) {
                        item.procedimentosQuantidade.push({
                            codigo: this.enums.procedimento.ULOTOMIA_ULECTOMIA,
                            quantidade: item.atendimentoOdontologico.procedimentosQuantidade.ulotomiaUlectomia
                        })
                    }

                    item.atendimentoOdontologico.procedimentos = item.procedimentos
                        .filter(procedimento => procedimento.usuarioId === item.usuarioId)

                    if (!item.ocupacaoId) {

                        const especialidade = item.especialidadesJornada
                            .find(especialidade => especialidade.id === item.especialidadeId);

                        if (especialidade) {
                            item.ocupacaoId = especialidade.ocupacao.id;
                        }
                    }
                }
            });

            return this.camelObjectKeysToSnakeRecursive({
                consultas
            })
        },
        handleProcedimentos(procedimentos) {
            this.procedimentos = procedimentos;
        }
    },
    mixins: [error, mask, object, repository, data, formats, stringCase],
    mounted() {
        this.load()
    },
}
</script>